export const language: any ={
  title: "Cộng đồng Hey! Cooker",
  follow: "Theo dõi",
  follower: "Người theo dõi",
  post_share: "Bài chia sẻ",
  like_share: "Yêu thích",
  report: "Báo cáo vi phạm",
  delete_post: "Xóa bài đăng",
  delete_comment: "Xóa bình luận",
  confirm_report: "Bạn chắc chắn bài đăng này chứa nội dung vi phạm nguyên tắc cộng đồng? Sau khi báo cáo thành công, bạn sẽ không nhìn thấy bài đăng này nữa",
  confirm_report_comment: "Bạn chắc chắn bình luận này vi phạm nguyên tắc cộng đồng?",
  toats_report: "Cảm ơn đã báo cáo vi phạm, báo cáo của bạn đang được xem xét",
  confirm_delete: "Bạn có muốn xóa bài đăng này không?",
  confirm_delete_comment: "Bạn chắc chắn xóa bình luận này?",
  toast_delete: "Đã xóa thành công!",
  text_yes: "Có",
  text_no: "Không",
  create: {
    title: "Tạo bài viết - Cộng đồng Hey!Cooker",
    content_placeholder: "Nhập nội dung bài viết của bạn",
    submit: "Chia sẻ nội dung ngay",
    add_image_by_camera: "Chụp bằng camera",
    add_image_by_gallery: "Chọn hình ảnh",
    add_video_by_camera: "Quay video",
    add_video_by_gallery: "Chọn video",
  },
  detail:{
    shared: "Đã chia sẻ",
    shared_community: "Đã chia sẻ ảnh (video) với cộng đồng",
  },
  follwed: "Đã theo dõi",
  comment: {
    placeholder: "Vui lòng viết nội dung",
    submit: "Gửi",
    nodata: "Hãy để lại bình luận để trở thành người đầu tiên bình luận cho nội dung này",
    load_more: "Xem thêm bình luận",
    not_login: "Vui lòng đăng nhập để bình luận",
    delete: "Xóa bình luận",
    delete_confirm: "Bạn chắc chắn xóa bình luận này?",
    delete_success: "Đã xóa bình luận",
    report: "Báo cáo vi phạm",
    report_confirm: "Bạn chắc chắn bình luận này vi phạm nguyên tắc cộng đồng?",
    report_success: "Cảm ơn đã báo cáo vi phạm,\nbáo cáo của bạn đang được xem xét",
  },
  bottom_navigation: "Cộng đồng",
  shared_post: "Đã chia sẻ bài đăng",
}

